<script lang="ts">
  interface Props {
    title: string;
    description: string;
    canonical: string;
    ogImage?: string;
    ogType?: string;
    ogSiteName?: string;
    noindex?: boolean;
    articlePublishedTime?: string;
    articleModifiedTime?: string;
    articleAuthor?: string;
  }

  let {
    title,
    description,
    canonical,
    ogImage = 'https://bleunk.com/og-default.png?v=2',
    ogType = 'website',
    ogSiteName = 'Bleunk Technologies',
    noindex = false,
    articlePublishedTime,
    articleModifiedTime,
    articleAuthor,
  }: Props = $props();
</script>

<svelte:head>
  <title>{title}</title>
  <meta name="description" content={description} />
  <link rel="canonical" href={canonical} />

  <!-- Open Graph / LinkedIn -->
  <meta property="og:title" content={title} />
  <meta property="og:description" content={description} />
  <meta property="og:url" content={canonical} />
  <meta property="og:image" content={ogImage} />
  <meta property="og:image:width" content="1200" />
  <meta property="og:image:height" content="630" />
  <meta property="og:type" content={ogType} />
  <meta property="og:site_name" content={ogSiteName} />
  <meta property="og:locale" content="en_PH" />

  <!-- Basic Twitter Card (No handles) -->
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={title} />
  <meta name="twitter:description" content={description} />
  <meta name="twitter:image" content={ogImage} />

  <!-- Article-specific (only rendered when ogType === 'article') -->
  {#if ogType === 'article' && articlePublishedTime}
    <meta property="article:published_time" content={articlePublishedTime} />
  {/if}
  {#if ogType === 'article' && articleModifiedTime}
    <meta property="article:modified_time" content={articleModifiedTime} />
  {/if}
  {#if ogType === 'article' && articleAuthor}
    <meta property="article:author" content={articleAuthor} />
    <meta property="article:section" content="Technology" />
  {/if}

  <!-- Robots -->
  {#if noindex}
    <meta name="robots" content="noindex, nofollow" />
  {:else}
    <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
  {/if}
</svelte:head>
